<template>
  <div>
    <b-container>

      <b-row align-v="center" align-h="center" class="mb-4">
        <b-col lg="9">
          <h2 class="h2-semibold-azure mb-4 text-center">Abbiamo trovato l’offerta perfetta per
            te!</h2>
          <b-row align-v="center">
            <b-col lg="5" offset-lg="1" class="mb-2 md:mb-4">
              <p class="h5-medium-black" style="max-width: 280px">Compila il form per ricevere l’offerta che fa al caso tuo.<br><strong class="h5-bold-black">È gratis e
                senza impegno!</strong></p>
            </b-col>
            <b-col lg="6" class="mb-2 md:mb-4">
              <p class="h6-bold-azure-uppercase text-uppercase mb-0">PAROLA DI SGR LUCE E GAS</p>
              <p class="h6-bold-black">• Garantiamo la protezione dei tuoi dati personali. <br>• Nessun costo nascosto,
                nessun impegno.<br>• La convenienza è a portata di click!</p>
            </b-col>
          </b-row>
          <b-row align-v="center">
            <b-col lg="12" class="mb-2 lg:mb-0 text-center">
              <h6 class="h5-semibold-black mb-3 text-center mx-auto">Compila il form per ricevere l’offerta via email.</h6>
              <div class="border-1" style="border-bottom: 1px solid #98AAB5; margin-bottom: 30px;"></div>
            </b-col>
          </b-row>
          <validation-observer ref="observer" v-slot="{ handleSubmit }">
            <b-form @submit.stop.prevent="handleSubmit(sendForm)">
              <div class="row">
                <div class="col-md-6">
                  <validation-provider
                      name="Nome"
                      :rules="{ required: true, min: 3 }"
                      v-slot="validationContext"
                  >
                    <div class="form-group">
                      <b-form-input v-model="customer.firstname" type="text" class="form-control form-control-gray-900"
                                    :state="getValidationState(validationContext)"
                                    aria-describedby="input-1-live-feedback"
                                    placeholder="Nome *"></b-form-input>
                      <b-form-invalid-feedback id="input-1-live-feedback">{{
                          validationContext.errors[0]
                        }}
                      </b-form-invalid-feedback>
                    </div>
                  </validation-provider>
                </div>
                <div class="col-md-6">
                  <validation-provider
                      name="Cognome"
                      :rules="{ required: true, min: 3 }"
                      v-slot="validationContext"
                  >
                    <div class="form-group">
                      <b-form-input v-model="customer.lastname" type="text" class="form-control form-control-gray-900"
                                    :state="getValidationState(validationContext)"
                                    aria-describedby="input-2-live-feedback"
                                    placeholder="Cognome *" required></b-form-input>
                      <b-form-invalid-feedback id="input-2-live-feedback">{{
                          validationContext.errors[0]
                        }}
                      </b-form-invalid-feedback>
                    </div>
                  </validation-provider>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12">
                  <validation-provider
                      name="Email"
                      :rules="{ required: true, min: 3, email: true }"
                      v-slot="validationContext"
                  >
                    <b-form-group>
                      <b-input-group>
                        <b-form-input v-model="customer.email" type="email" class="form-control form-control-gray-900"
                                      :state="getValidationState(validationContext)"
                                      aria-describedby="input-email-live-feedback"
                                      placeholder="Email *" required></b-form-input>
                      </b-input-group>
                      <b-form-invalid-feedback id="input-email-live-feedback">{{
                          validationContext.errors[0]
                        }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider
                      name="Telefono"
                      :rules="{ required: false, min: 6 }"
                      v-slot="validationContext"
                  >
                    <b-form-group>
                      <b-input-group>
                        <b-form-input v-model="customer.phone" type="tel" class="form-control form-control-gray-900"
                                      :state="getValidationState(validationContext)"
                                      aria-describedby="input-telefono-live-feedback"
                                      placeholder="Telefono"></b-form-input>
                      </b-input-group>
                      <b-form-invalid-feedback id="input-telefono-live-feedback">{{
                          validationContext.errors[0]
                        }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </div>
              </div>

              <b-form-group class="form-check" :state="stateCheck">
                <input type="checkbox" v-model="customer.privacy" :value="true" class="form-check-input"
                       id="privacyCheck"
                       required>
                <label class="form-check-label h8-regular-black" for="privacyCheck">
                  Acconsento al trattamento dei miei dati personali. Consulta la <a href="https://www.sgrlucegas.com/privacy-policy/" class="h8-regular-azure-underline" target="_blank">Privacy Policy</a>.</label>
              </b-form-group>

              <button type="submit" class="button-azure-rounded full-width" :disabled="formDisabled">
                INVIA
              </button>
              <p class="mt-2 text-right"><small>* campi obbligatori</small></p>
              <p class="recaptcha-disclaimer h8-regular-gray-600 mt-2 mb-0">
                Questo sito è protetto da reCAPTCHA e si applicano la
                <a href="https://policies.google.com/privacy" class="h8-regular-azure-underline" target="_blank" rel="noopener">Privacy Policy</a>
                e i <a href="https://policies.google.com/terms" class="h8-regular-azure-underline" target="_blank" rel="noopener">Termini di servizio</a>
                di Google.
              </p>
            </b-form>
          </validation-observer>

        </b-col>
      </b-row>

    </b-container>
  </div>
</template>

<script>
import Vue from "vue";
import { RECAPTCHA_ACTIONS, getRecaptchaToken } from '@/config/recaptcha';

export default {
  name: 'FormInviaStima',
  components: {},
  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    today.setDate(today.getDate() + 1)
    return {
      minDate: today,
      localOptions: null,
      rate: null,
      webPath: process.env.VUE_APP_WEB_PATH,

      customer: {
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        privacy: null,
        city: ''
      }
    }
  },
  props: {
    options: {
      type: [Array, Object],
      required: true
    },
    utilityType: {
      type: String,
      required: true
    }
  },
  computed: {
    rata() {
      let rata = '';
      let optionsRate = this.rate;
      switch (this.utilityType) {
        case 'Gas':
          rata = optionsRate.Gas;
          break;
        case 'Electricity':
          rata = optionsRate.Electricity;
          break;
        case 'Dual':
          rata = {
            Electricity: {
              Amount: optionsRate.Electricity.Amount
            },
            Gas: {
              Amount: optionsRate.Gas.Amount
            },
            Amount: (optionsRate.Electricity.Amount * 1) + (optionsRate.Gas.Amount * 1)
          };
          break;
      }
      return rata;
    },
    formDisabled() {
      return (this.customer.firstname != null && this.customer.firstname.length < 1)
          || (this.customer.lastname != null && this.customer.lastname.length < 1)
          || (this.customer.email != null && this.customer.email.length < 1)
          || !this.customer.privacy
    },
    stateCheck: function () {
      return this.customer.privacy;
    }
  },
  created() {
    this.$root.footer = false;
    this.localOptions = this._.cloneDeep(this.options);

    if (!this._.isEmpty(this.localOptions.cliente)) {
      this.customer.firstname = this.localOptions.cliente.FirstName;
      this.customer.lastname = this.localOptions.cliente.LastName;
      this.customer.email = this.localOptions.cliente.Email;
      this.customer.phone = this.localOptions.cliente.Mobile;
    }

    this.customer.city = this.localOptions.comune;

    this.getRate();

    if(typeof window.fbq != 'undefined') {
      this.trackFbViewContent('configuratore_serena', 'step-invia-stima');
    }
  },
  methods: {
    getValidationState({dirty, validated, valid = null}) {
      return dirty || validated ? valid : null;
    },
    async getRate() {
      let that = this;
      var utilityType = '';
      if(typeof that.localOptions.forniture.Connections !== 'undefined')
      {
        utilityType = that.localOptions.forniture.Connections.length == 2 ? 'Dual' : that.localOptions.forniture.Connections[0].UtilityType == 'EE' ? 'Electricity' : 'Gas';
      }
      else
      {
        utilityType = that.localOptions.forniture.UtilityType;
      }
      var cc = null;
      var c = null;
      let istat = that.localOptions.comune.istat;
      let consumi = [];
      let params = null;
      switch (utilityType) {
        case 'Electricity':
          if(typeof that.localOptions.forniture.Connections !== 'undefined')
          {
            c = that.localOptions.forniture.Connections.find(item => item.UtilityType == 'EE');
            cc = that.localOptions.consumo.find(item => item.UtilityType == 'Electricity');
            params = {
              UtilityType: 'Electricity',
              ISTATCode: istat,
              PowerCommitted: c.PotenzaImpegnata,
              Residential: c.Residential,
              Consumption: cc.Consumption,
            };
          }
          else
          {
            params = {
              UtilityType: 'Electricity',
              ISTATCode: istat,
              PowerCommitted: that.localOptions.forniture.potenza,
              Residential: that.localOptions.forniture.residenza,
              Consumption: that.localOptions.forniture.consumi.Electricity,
            };
          }

          await that.getRata(params);
          consumi.push(params);
          break;
        case 'Gas':
          if(typeof that.localOptions.forniture.Connections !== 'undefined')
          {
            c = that.localOptions.forniture.Connections.find(item => item.UtilityType != 'EE');
            cc = that.localOptions.consumo.find(item => item.UtilityType == 'Gas');
            params = {
              UtilityType: 'Gas',
              ISTATCode: istat,
              Consumption: cc.Consumption,
            };
          }
          else
          {
            params = {
              UtilityType: 'Gas',
              ISTATCode: istat,
              Consumption: that.localOptions.forniture.consumi.Gas,
            };
          }
          await that.getRata(params);
          consumi.push(params);
          break;
        case 'Dual':
          if(typeof that.localOptions.forniture.Connections !== 'undefined')
          {
            c = that.localOptions.forniture.Connections.find(item => item.UtilityType == 'EE');
            cc = that.localOptions.consumo.find(item => item.UtilityType == 'Electricity');
            params = {
              UtilityType: 'Electricity',
              ISTATCode: istat,
              PowerCommitted: c.PotenzaImpegnata,
              Residential: c.Residential,
              Consumption: cc.Consumption,
            };
            await that.getRata(params);
            consumi.push(params);

            c = that.localOptions.forniture.Connections.find(item => item.UtilityType != 'EE');
            cc = that.localOptions.consumo.find(item => item.UtilityType == 'Gas');

            params = {
              UtilityType: 'Gas',
              ISTATCode: istat,
              Consumption: cc.Consumption,
            };
            await that.getRata(params);
            consumi.push(params);
          }
          else
          {
            params = {
              UtilityType: 'Electricity',
              ISTATCode: istat,
              PowerCommitted: that.localOptions.forniture.potenza,
              Residential: that.localOptions.forniture.residenza,
              Consumption: that.localOptions.forniture.consumi.Electricity,
            };
            await that.getRata(params);
            consumi.push(params);

            params = {
              UtilityType: 'Gas',
              ISTATCode: istat,
              Consumption: that.localOptions.forniture.consumi.Gas,
            };
            await that.getRata(params);
            consumi.push(params);
          }

          break;
      }

      /*
       * Ottengo URL per switch online
       */
      if(this.rate)
      {
        let istat = that.localOptions.comune.istat;
        that.axios.post(that.webPath + 'wp-admin/admin-ajax.php?action=relax_get_link_switchonline_no_customer&ISTATCode=' + istat + '&UtilityType=' + that.realUtilityType, this.rate)
            .then((response) => {
              let data = that.decryptAES(response.data);
              if (data.success) {
                this.switchOnlineUrl = data.data;
              }
            })
            .catch((error) => {
              this.captureExceptionSentry(error);
            })
      }

      that.loaded = true;
      let rateOptions = that._.cloneDeep(that.rate)
      Vue.set(that.localOptions, 'rate', rateOptions)
      that.$emit('updateOptions', that.localOptions);
    },
    getRata(params) {
      let that = this;
      that.rate = that.rate || [];
      that.$root.loading = true;
      params['action'] = 'relax_get_rata'
      return that.axios.get(that.webPath + 'wp-admin/admin-ajax.php', {params: params})
        .then((response) => {
          let data = that.decryptAES(response.data);
          if ((typeof data.error !== 'undefined' && data.error) || !data.success) {
            let noRetry = false;
            if(typeof data.error === 'undefined' && !data.success && typeof data.redirecthome !== 'undefined') noRetry = true;
            that.showAlertModal(data.message, noRetry).then(() => {
              that.goToBack();
            })
          } else if (data.success) {
            Vue.set(that.rate, params.UtilityType, data.data);
          }
          that.$root.loading = false;
          return true;
        })
        .catch((error) => {
          this.captureExceptionSentry(error);
          let message = 'Qualcosa è andato storto, ti invitiamo a riprovare.'
          that.showAlertModal(message).then(() => {
            that.goToBack()
          })
          return false;
        })
    },
    goToBack(){
      this.$router.back();
    },
    async sendForm() {
      let that = this;
      if (!that.customer.privacy) return false;
      that.$root.loading = true;

      let consumoEE = -1, consumoGM = -1;
      let amountEE = -1, amountGM = -1;
      let power = -1, residential = -1;

      if (typeof that.rate.Electricity !== 'undefined' && that.rate.Electricity !== null) {
        consumoEE = that.rate.Electricity.Consumption;
        amountEE = that.rate.Electricity.Amount;
        power = that.rate.Electricity.PowerCommitted;
        residential = that.rate.Electricity.Resident;
      }
      if (typeof that.rate.Gas !== 'undefined' && that.rate.Gas !== null) {
        consumoGM = that.rate.Gas.Consumption;
        amountGM = that.rate.Gas.Amount;
      }

      let params = {
        customer: {
          Firstname: that.customer.firstname,
          Lastname: that.customer.lastname,
          Email: that.customer.email,
          Phone: that.customer.phone,
          City: that.customer.city,
        },
        offer: {
          NewCustomer: !that.localOptions.seiCliente,
          Amount: that.rata.Amount,
          AmountEE: amountEE,
          AmountGM: amountGM,
          Power: power,
          Residential: residential,
          ISTATCode: that.localOptions.comune.istat,
          ConsumptionEE: consumoEE,
          ConsumptionGM: consumoGM
        }
      }

      if( typeof this.localOptions.wizard !== 'undefined')
        params.wizard = this.localOptions.wizard;

      if( typeof this.localOptions.cliente !== 'undefined' && this.localOptions.cliente !== null && typeof this.localOptions.cliente.FiscalCode !== 'undefined' && this.localOptions.cliente.FiscalCode !== null)
        params.customer.FiscalCode = this.localOptions.cliente.FiscalCode;

      if( typeof this.localOptions.cliente !== 'undefined' && this.localOptions.cliente !== null && typeof this.localOptions.cliente.ContractNumber !== 'undefined' && this.localOptions.cliente.ContractNumber !== null)
        params.customer.ContractNumber = this.localOptions.cliente.ContractNumber;

      params.recaptcha_action = RECAPTCHA_ACTIONS.SEND_QUOTATION;
      params.recaptcha_token = await getRecaptchaToken(RECAPTCHA_ACTIONS.SEND_QUOTATION);

      that.axios.post(that.webPath + 'wp-admin/admin-ajax.php?action=relax_send_email_quotation', params)
        .then((response) => {
          let data = that.decryptAES(response.data);
          if ((typeof data.error !== 'undefined' && data.error) || !data.success) {
            that.showAlertModal(data.message)
            that.$root.loading = false;
          } else if (data.success) {

            if (typeof window.gtag !== 'undefined') {
              window.gtag('event', 'contatto', { 'event_category': 'configuratore-serena', 'event_label': 'invio-stima-' + data.nameOffer });
            }
            if(typeof window.fbq != 'undefined') {
              this.trackFbLead('configuratore_serena', 'invio-stima-' + data.nameOffer);
            }
            setTimeout(() => {
              that.$router.push({name: 'message-sent', params: {type: 'invio-stima'}});
            }, 1000);
          }
        })
        .catch((error) => {
          this.captureExceptionSentry(error);
          let message = "Qualcosa è andato storto, riprovare più tardi."
          this.showAlertModal(message)
          this.$root.loading = false;
        })
    }
  },
}
</script>

<style scoped lang="scss">
button[type=submit] {
  font-size: 16px;
}
</style>